import { Box, Typography } from '@mui/material';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';

import Card from '../Card';
import NoItems from '../NoItems';
import RecentlyOpen from '../RecentOpen';

import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomTab from 'components/shared/CustomTab/CustomTab';

import { SearchCategoryType } from 'model/gloabalSearch.model';
import { GlobalSearchService } from 'service/global-search.service';
import zeplinColor from 'theme/Color';
import { Utilities } from 'utilities/utilities';

const TABS_DUMMY_DATA = [
  'all',
  'clients',
  'tasks',
  'deals',
  'leads',
  'contacts',
  'team',
  'business',
];

const DropDown = ({
  searchValue,
  handleCloseSearch,
}: {
  searchValue: string;
  handleCloseSearch: () => void;
}) => {
  const [tabValue, setTabValue] = useState(0);
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const selectedTab = TABS_DUMMY_DATA[tabValue] as SearchCategoryType;
  const selectedTabData = data[selectedTab];
  const isAllTabSelected = selectedTab === 'all';
  const isSearchEmpty = useRef(false);

  const tabs = TABS_DUMMY_DATA.map((tab, index) => {
    return {
      label: Utilities.capitalize(tab),
      id: index + 1,
      isHidden: tabValue !== index,
      Component: <></>,
    };
  });

  const handleTabChange = (_: SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    const fetch = async () => {
      if (searchValue) {
        setLoading(true);
        const res = await GlobalSearchService.getSearchResults({
          q: searchValue,
          category: selectedTab,
        });
        setData(res.results);

        isSearchEmpty.current = res.totalResults === 0;

        setLoading(false);
      }
    };
    fetch();
  }, [searchValue, selectedTab]);

  if (loading) {
    return (
      <Box
        sx={{
          position: 'absolute',
          zIndex: '100',
          bgcolor: zeplinColor.Neutral1,
          width: '100%',
          boxShadow: '0 2px 15px #00000026',
          borderRadius: '16px',
          padding: '16px',
          marginTop: '4px',
        }}
      >
        <Box
          sx={{
            width: '100%',
            marginBottom: '4px',
          }}
        >
          <CustomTab tabs={tabs} handleChange={handleTabChange} value={tabValue} />
        </Box>
        <Box
          sx={{
            maxHeight: '600px',
            overflow: 'scroll',
          }}
        >
          Loading...
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        zIndex: '10',
        bgcolor: zeplinColor.Neutral1,
        width: '100%',
        boxShadow: '0 2px 15px #00000026',
        borderRadius: '16px',
        padding: '16px',
        marginTop: '4px',
      }}
    >
      <Box
        sx={{
          width: '100%',
          marginBottom: '4px',
        }}
      >
        <CustomTab tabs={tabs} handleChange={handleTabChange} value={tabValue} />
      </Box>
      <Box
        sx={{
          maxHeight: '600px',
          overflow: 'scroll',
        }}
      >
        {!searchValue && <RecentlyOpen handleCloseSearch={handleCloseSearch} />}

        {isSearchEmpty.current && searchValue && <NoItems />}

        {!isSearchEmpty.current && isAllTabSelected && searchValue && (
          <Box>
            {Object.keys(data).map((category) => {
              const { items, count, label } = data[category];

              if (!count) return <></>;

              return (
                <Box key={category}>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Typography>
                      {label} ({count})
                    </Typography>

                    <CustomButton
                      variant={'text'}
                      text={<Typography variant='responsiveButtonSmall'>View All</Typography>}
                      onClick={(e: SyntheticEvent) => {
                        handleTabChange(
                          e,
                          TABS_DUMMY_DATA.findIndex((item) => item === category),
                        );
                      }}
                      disabled={false}
                    />
                  </Box>

                  {items.length &&
                    items.map((item: any) => (
                      <Card
                        key={item.id}
                        category={category as SearchCategoryType}
                        product={item}
                        handleCloseSearch={handleCloseSearch}
                      />
                    ))}
                </Box>
              );
            })}
          </Box>
        )}

        {!isSearchEmpty.current && selectedTabData && searchValue && (
          <Box>
            <Typography variant='responsiveBody3'>
              {selectedTabData.label} ({selectedTabData.count})
            </Typography>
            {selectedTabData.items.length &&
              selectedTabData.items.map((item: any) => (
                <Card
                  key={item.id}
                  category={selectedTab}
                  product={item}
                  handleCloseSearch={handleCloseSearch}
                />
              ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default DropDown;
